<!--
 * @Description: 政策项目申报
 * @Author: LXG
 * @Date: 2021-04-27
 * @Editors: LXG
 * @LastEditTime: 2021-06-26
-->
<template>
    <div class="policy-declaration">
        <!-- banner -->
<!--        <div class="banner-size">
            &lt;!&ndash; <div class="banner-inner">
                <span class="banner-fMax">申报详情</span>
                <span class="banner-fMin">送政策、送服务，助推企业发展</span>
            </div> &ndash;&gt;
        </div>-->
        <div class="def-container marg-tb-2 pd-content">
            <h2 class="pd-title">{{policyData.name||projectData.sxmc}}</h2>
            <el-steps
                class="pd-steps"
                :active="stepInfo.active"
                finish-status="success"
                process-status="finish"
                align-center
            >
                <el-step
                    v-for="(item,index) in stepInfo.list"
                    :key="index"
                    :title="item.label"
                ></el-step>
            </el-steps>
            <div class="container">
                <!-- 申请须知 -->
                <div
                    v-show="stepInfo.active===0"
                    class="step-one-content"
                >
                      <Enterprise
                          ref="enterprise"
                          v-model="enterpriseData"
                      ></Enterprise>
                      <Agent
                          ref="agent"
                          v-model="agentData"
                      ></Agent>
                    <div  v-if="ifProject">
                    <Project
                        ref="project"
                        v-model="moreData"
                    ></Project>
                    </div>
                    <Notice ref="notice"></Notice>
                </div>
                <!-- 填写信息 -->
                <!-- <div
                    v-if="ifProject"
                    v-show="stepInfo.active===0"
                >

                </div> -->
                <!-- 上传材料 -->
                <div v-show="stepInfo.active===1">
                    <Material v-model="materialData"></Material>
                </div>
                <!-- 确认信息 -->
                <div
                    v-if="stepInfo.active===2"
                    class="step-confirm"
                >
                    <Enterprise
                        v-model="enterpriseData"
                        disabled
                    ></Enterprise>
                    <Agent
                        v-model="agentData"
                        disabled
                    ></Agent>
                    <div v-if="ifProject">
                    <Project
                        class="confirm-project"
                        v-model="moreData"
                        disabled
                    ></Project>
                    </div>

                    <Material
                        v-model="materialData"
                        disabled
                    ></Material>
                </div>
                <!-- 提交成功 -->
                <div
                    v-show="stepInfo.active===3"
                    class="step-success"
                >
                    <div class="step-success-icon">
                        <i class="el-icon-success"></i>
                    </div>
                    <p class="step-success-text">
                        您的业务编号{{newProjectId}}政策已提交至业务部门审核，您可以登录，
                        <span>“信阳市免申即享企业服务平台”PC端</span>->工作台->我的项目查看项目审核详情。
<!--                        或-->
<!--                        <span>“信阳企业直通车平台”小程序</span>-->
<!--                        查看业务办理最新进度。-->
                    </p>
                    <!-- <p>
                        操作成功，
                        <span>{{countdown}}</span>
                        秒后前往个人工作台
                    </p> -->
                    <el-button
                        type="primary"
                        @click="goWorkplace"
                    >返回个人工作台</el-button>
                </div>
            </div>
            <div class="footBtns">
                <el-button
                    v-for="(item,index) in cpu_footBtns"
                    :key="index"
                    :type="item.type"
                    @click="clickFootBtn(item)"
                >{{item.label}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Enterprise from './components/enterprise/Enterprise'
import Agent from './components/agent/Agent'
import Notice from './components/notice/Notice'
import Project from './components/project/Project'
import Material from './components/material/Material'
// import { decrypt } from '@/utils/aes.js'

export default {
    name: 'PolicyDeclaration',
    components: {
        Enterprise,
        Agent,
        Notice,
        Project,
        Material,
    },
    data() {
        return {
            projectId: '', // 政策项目ID
            projectData: {}, // 政策项目信息(暂存、退回等状态用)
            policyData: {}, // 政策信息
            companyData: {}, // 企业信息
            stepInfo: {
                active: 0,
                list: [
                    { label: '申请告知' },
                  //  { label: '填写信息' },
                    { label: '上传材料' },
                    { label: '确认信息' },
                    { label: '提交成功' },
                ]
            },
            // 申请企业信息
            enterpriseData: {
                unitname: '', // 名称
                unitcardtype: '100008', // 证件类型
                unitcardcode: '', // 证件号码
                unitaddress: '', // 地址
                legalperson: '', // 法人姓名
                legalcardtype: '100001', // 法人证件类型
                legalcardnum: '', // 法人证件号码
                unitemail: '', // 企业电子邮箱
                unitpostcode: '', // 企业邮政编码
                unittel: '', // 企业联系电话
            },
            // 经办人信息
            agentData: {
                agentname: '', // 姓名
                agentcertificatetype: '100001', // 证件类型
                agentcertificatenumber: '', // 证件号码
                agentmobilephone: '', // 联系电话
                agentaddress: '', // 联系地址
                agentbirthday: '', // 出生日期
                agentcertificatename: '身份证', // 证件名称
                agentemail: '', // 电子邮箱
                agentgender: '', // 性别
                agentuserid: '', // 用户ID
            },
            // 动态表单信息(更多信息)
            moreData: {
                bsnum: '', // 业务流水号
                formdata: '', // 表单结构JSON
                formid: '', // 表单ID
                formtype: '0', // 表单类型{'0':业务表单}
                id: '', // 业务表单ID(新申报是为空)
                subdata: '', // 表单数据JSON
            },
            materialData: [], // 材料信息
            countdown: 10, // 倒计时返回
            backTimer: null, // 计时器
            newProjectId: '', // 新申报的项目ID
            ifProject: true,
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo',
        }),
        /**
         * @description 底部按钮组
         */
        cpu_footBtns() {
            let list = []
            if (0 < this.stepInfo.active && this.stepInfo.active < this.stepInfo.list.length - 1) {
                list = [{ label: '上一步', type: '', methodName: 'lastStep' }]
            }
            if (this.stepInfo.active < this.stepInfo.list.length - 2) {
                list.push({ label: '下一步', type: 'primary', methodName: 'nextStep' })
            }
            if (this.stepInfo.active === this.stepInfo.list.length - 2) {
                list.push({ label: '打印', type: 'primary', methodName: 'print' })
            }
            if (this.stepInfo.active === this.stepInfo.list.length - 2) {
                list.push({ label: '确认兑现', type: 'primary', methodName: 'submit' })
            }

            return list
        },
        /**
         * @description: 政策ID(事项ID)
         * @return {String}
         */
        cpu_policyId() {
            if (!this.projectId) {
                return this.policyData.id
            } else {
                return this.projectData.sxid
            }
        },
    },
    methods: {
        clickFootBtn(item) {
            this[item.methodName]()
        },
        /**
         * @description 上一步
         */
        lastStep() {
            this.stepInfo.active--
        },
        print(){
           window.print();
        },
        /**
         * @description 下一步
         */
        async nextStep() {
            switch (this.stepInfo.active) {
                case 0:
                   var bool = true;
                   this.$refs['agent'].$refs['form'].validate(valid => {
                        if (!valid) {
                            bool = false;
                            this.$message.warning('请填写完整的信息')
                            return
                        }
                        if (!this.$refs['notice'].checked) {
                            bool = false;
                            this.$message.warning('请阅读并同意《服务协议》')
                            return
                        }


                })
                  let newFormData;
                  if(this.ifProject){
                    let flag = this.$refs['project'].$refs['parseFormViewDiv'];
                  if(flag != undefined){
                    newFormData = await flag.getFormData();
                     console.log("newFormData ===== ",flag.getFormData())
                    if (newFormData == null ) {
                      bool = false;
                      this.$message.warning('请检查填写的表单信息')
                      return
                    }

                    /*flag.getFormData().then((data) => {
                      console.log("---66666666666666666666666666666666666666----index的:", data);
                    });*/

                  }
                   this.moreData.subdata = JSON.stringify(newFormData)
                }
                if(bool){
                     this.stepInfo.active++
                }


                    // if (!this.$refs['project'].$refs['parseFormViewDiv']) {
                    //     this.$message.error('错误，未读取到项目表单信息')
                    //     return
                    // }
                    break
                case 1:
                    // 校验材料的必传
                    for (let i = 0; i < this.materialData.length; i++) {
                        const material = this.materialData[i]
                        if (material.isneed == '1' && !material.tempFiles.length) {
                            this.$message.warning('请上传必要的材料文件')
                            return
                        }
                    }
                    this.stepInfo.active++
                    break
                default:
                    break
            }
        },
        /**
         * @description: 提交申报
         */
        submit() {
            // console.log('policyData:', this.policyData)
            // console.log('moreData:', this.moreData)
            // console.log('materialData:', this.materialData)
            // console.log('agentData:', this.agentData)
            // console.log('enterpriseData:', this.enterpriseData)

            this.$confirm('确认申报信息无误', '申报确认', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(async () => {
                let params = {}
                debugger
                // 业务信息(新申报时，很多字段没有值，忽略掉)
                if (this.projectId) {
                    params.baseinfo = JSON.parse(JSON.stringify(this.projectData))
                    // 修正数据
                    params.baseinfo.bsnum = params.baseinfo.id
                    Reflect.deleteProperty(params.baseinfo, 'id')
                } else {
                    params.baseinfo = {
                        bstype: '1', // 业务类型{'1':企业, '2':个人}
                        deptid: this.policyData.deptCode, // 部门ID
                        deptname: this.policyData.deptName, // 部门名称
                        sxid: this.policyData.id, // 事项ID(政策ID？)
                        sxmc: this.policyData.name, // 事项名称(政策名称？)
                        type: '1', // 业务来源
                    }
                }
                // 处理信息
                // params.dealInfo = {}
                // 业务表单信息
              //  params.formInfo = {}
              let flag = undefined;
              if(this.ifProject){
              flag = this.$refs['project'].$refs['parseFormViewDiv'];
              }
              if(flag != undefined){
                params.formInfo = JSON.parse(JSON.stringify(this.moreData))
                let newFormData = await flag.getFormData()
                params.formInfo.subdata = JSON.stringify(newFormData) || ''
                params.formInfo = [params.formInfo]
              }else{
                params.formInfo = {}
                this.$set(params.formInfo, 'id', "")
                this.$set(params.formInfo, 'bsnum', "")
                this.$set(params.formInfo, 'subdata', "{}")
                this.$set(params.formInfo, 'formdata', "{}")
                this.$set(params.formInfo, 'formtype', "")
                this.$set(params.formInfo, 'formid', "")
                params.formInfo = [params.formInfo]
              }
                // 附加信息
                // params.info = {}
                // 业务材料信息
                params.materials = JSON.parse(JSON.stringify(this.materialData))
                for (let i = 0; i < params.materials.length; i++) {
                    const material = params.materials[i]
                    material.files = material.tempFiles.map(cv => {
                        return {
                            fileid: cv.fileid,
                            filename: cv.filename,
                            filepath: cv.filepath || cv.viewUrl || '',
                            id: '',
                            ly: cv.ly || material.ly || '',
                            mid: cv.mid || material.id || '',
                            status: '1',
                        }
                    })
                }
                // 申报对象信息
                params.operator = {}
                //     经办人信息
                params.operator.agent = JSON.parse(JSON.stringify(this.agentData))
                //     申报类型{'1':企业, '2':个人}
                params.operator.apptype = '1'
                //     企业信息
                params.operator.enterprise = JSON.parse(JSON.stringify(this.enterpriseData))
                //     操作人用户(登录用户)信息
                params.operator.reporter = {
                    operateaccount: this.userInfo.userName, // 用户账号
                    operateid: this.userInfo.userId, // 用户ID
                    optaddress: '', // 地址
                    optbirthday: '', // 出生日期
                    optcertificatename: '身份证', // 证件名称
                    optcertificatenumber: '', // 证件号码
                    optcertificatetype: '10001', // 证件类型
                    optemail: '', // 电子邮箱
                    optgender: this.userInfo.sex, // 性别
                    optmobilephone: this.userInfo.userName, // 电话号码
                    optname: this.userInfo.nickName, // 姓名
                }
                // 诉求工单信息
                // params.sqInfo = {}
                // 业务状态信息
                params.statusInfo = {
                    start: true,
                }
                // 信息填报
                // params.xxtbInfos = {}

                this.declarePolicy(params, () => {
                    this.stepInfo.active = this.stepInfo.list.length - 1
                    // this.backTimer = setInterval(() => {
                    //     this.countdown -= 1
                    //     if (this.countdown === 0) {
                    //         clearInterval(this.backTimer)

                    //         this.$router.replace({
                    //             path: '/workplace/index',
                    //         })
                    //     }
                    // }, 1000)
                })
            }).catch(() => { })

        },
        /**
         * @description: 前往工作台
         */
        goWorkplace() {
            this.$router.replace({
                path: '/workplace/index',
            })
        },
        /**
         * @description: 查询政策信息
         * @param {String} id 政策ID
         */
        getPolicyData(id) {
            let url = `/dev-api/basicinfo/baseitem/${id}`
            let params = {}
            this.$httpApi.get(url, params).then(res => {
                console.log('getPolicyData:', res)
                if (res.code == 200) {
                    this.policyData = res.data.itemList[0]

                    // 通过 表单ID 查询项目信息
                    this.getFormData(this.policyData.formid)
                    // 取出 材料列表
                    this.materialData = this.policyData.clxxList.map(cv => {
                        return {
                            bsnum: cv.bsnum || '', // 业务流水号
                            certid: cv.certid || '', // 证照ID
                            clbm: cv.clbm || '', // 材料编码
                            clid: cv.clid || '', // 材料ID
                            clmc: cv.clname || '', // 材料名称
                            copynum: cv.copynum || '', // 复印件份数
                            // 附件
                            files: [
                                // {
                                //     fileid: '', // 文件ID
                                //     filename: '', // 文件名称
                                //     filepath: '', // 文件路径
                                //     id: '',
                                //     ly: '', // 来源
                                //     mid: '', // 材料ID
                                //     status: '1', // 状态{'1':生效}
                                // },
                            ],
                            tempFiles: [], // 临时附件，页面用
                            id: '',
                            isneed: cv.sfby || '0', // 是否必要
                            ly: cv.ly || '', // 来源
                            orinum: cv.orinum || '', // 原件份数
                            sfrq: cv.sfrq || '1', // 是否容缺
                            shyj: cv.shyj || '', // 审批意见
                            shzt: cv.shzt || '0', // 审批状态{'0':未审核}
                            status: cv.status || '1', // 状态{'1':提交}
                            submittype: cv.submittype || '', // 提交类型
                            sxid: cv.sxid || '', // 事项ID
                            yburl: cv.yburl || '', // 是个啥？

                            tbxz: cv.tbxz || '', // 填报须知
                            ybid: cv.ybid || '', // 样表文件ID
                        }
                    })
                }
            }).catch(err => {
                console.log('getPolicyData error:', err);

            })
        },
        /**
         * @description 查询企业信息
         * @param {String} code 统一社会信用代码
         */
        getCompanyData(code) {
            let url = `/dev-api/sqzdManager/data/find/sq_qyhx_new_baseinfo_query`
            let params = {
                tyshxydm: code,
            }
            this.$httpApi.post(url, params).then(res => {
                // console.log('getCompanyData:', res)
                this.companyData = res.data[0] || {}

                // 新申报时填充初始数据
                if (!this.projectId) {
                    // 企业信息
                    this.enterpriseData.unitaddress = this.companyData.zcdz
                    this.enterpriseData.legalperson = this.companyData.frdb
                }
            }).catch(err => {
                console.log('getCompanyData error:', err)
            })
        },
        /**
         * @description 查询登录用户的联系人信息
         * @param {String} tyshxydm 统一社会信用代码
         */
        getUserContactData(tyshxydm) {
            let url = '/dev-api/enterprise/contact/list'
            let params = {
                webEid: tyshxydm,
                pageNum: 0,
                pageSize: 10,
            }
            this.$httpApi.get(url, params).then(res => {
                // console.log('getUserContactData:', res)
                if (res.code == 200 && !!res.rows.length) {
                    this.agentData.agentcertificatenumber = res.rows[0].zjh
                }
            }).catch(err => {
                console.log('getUserContactData error:', err)
            })
        },
        /**
         * @description 查询登录用户的办公地址信息
         * @param {String} tyshxydm 统一社会信用代码
         */
        getUserAddressData(tyshxydm) {
            let url = '/dev-api/enterprise/address/list'
            let params = {
                webEid: tyshxydm,
                pageNum: 0,
                pageSize: 10,
            }
            this.$httpApi.get(url, params).then(res => {
                // console.log('getUserContactData:', res)
                if (res.code == 200 && !!res.rows.length) {
                    this.agentData.agentaddress = res.rows[0].address
                }
            }).catch(err => {
                console.log('getUserContactData error:', err)
            })
        },
        /**
         * @description 查询动态表单信息
         * @param {String} formId 表单ID
         */
        getFormData(formId) {
            let url = `/dev-api/basicinfomanage/info/${formId}`
            if(formId == null){
                this.ifProject = false;
            }
            let params = {}
            this.$httpApi.get(url, params).then(res => {
            //    console.log("ifProject======",this.ifProject)
                if (res.code == 200) {
                    this.moreData.formdata = res.data.formContent
                    this.moreData.formid = res.data.id
                }
            }).catch(err => {
                this.ifProject = false;
              //  console.log("ifProject======",this.ifProject)
                console.log('getFormData error:', err)
            })
        },
        /**
         * @description 查询政策项目信息(暂存、退回时)
         * @param {String} id 项目ID
         */
        getProjectData(id) {
            let url = `/dev-api/userBusiness/getBusinessInfo?id=${id}`
            let params = {}
            const loading = this.$loading({})
            this.$httpApi.post(url, params).then(res => {
                console.log('getProjectData:', res)
                loading.close()
                if (res.code == 200) {
                    this.projectData = res.data.masterinfo
                    let baseData = JSON.parse(res.data.basicInfo.subdata)
                    this.enterpriseData = baseData.enterprise
                    this.agentData = baseData.agent
                    this.moreData = res.data.formData
                    this.materialData = res.data.material.map(cv => {
                        let obj = JSON.parse(JSON.stringify(cv))
                        obj.tempFiles = obj.masterinfoList.map(file => {
                            return {
                                ...file,
                                name: file.filename,
                                url: `${this.$httpApi.baseUrl}/dev-api/fileManageApi/common/fileView/${file.fileid}`,
                            }
                        })
                        // Reflect.deleteProperty(obj, masterinfoList)

                        return obj
                    })
                }
            }).catch(err => {
                console.log('getProjectData error:', err)
                loading.close()
            })
        },
        /**
         * @description: 申报政策项目
         * @param {Object} params 请求参数
         * @param {Function} cb 回调函数
         */
        declarePolicy(params, cb) {
            const loading = this.$loading({})
            let url = '/dev-api/business/handle/report'
            this.$httpApi.post(url, params).then(res => {
                // console.log('declarePolicy:', res)
                loading.close()
                if (res.code == 200) {
                    this.newProjectId = res.msg
                    cb()
                } else {
                    this.$message.error('操作错误，请检查')
                }
            }).catch(err => {
                console.log('declarePolicy error:', err)
                loading.close()
                this.$message.error('错误：', err)
            })
        },
    },
    provide() {
        return {
            policyData: () => this.policyData,
            policyId: () => this.cpu_policyId,
            companyData: () => this.companyData,
            enterpriseData: () => this.enterpriseData,
        }
    },
    created() {
        if (this.$route.query.pId) {
            this.projectId = this.$route.query.pId
            this.getProjectData(this.projectId)
        } else {
            this.getPolicyData(this.$route.query.policyId,this.$route.query.type)
        }
    },
    beforeDestroy() {
        if (this.backTimer) {
            clearInterval(this.backTimer)
        }
    },
    watch: {
        userInfo: {
            immediate: true,
            handler: function (newVal) {
                // console.log('userInfo:', newVal)
                if (!newVal) return
                // 携带pId(项目ID)过来的，不需要获取初始值
                // 直接查询项目信息赋值
                if (!this.$route.query.pId) {
                    // 补充 企业信息&&经办人信息
                  console.log('--------------',newVal);
                    this.enterpriseData.unitname = newVal.enterpriseInfo?.enterprise
                    this.enterpriseData.unitcardcode = newVal.tyshxydm
                    this.agentData.agentname = newVal.nickName
                    this.agentData.agentmobilephone = newVal.phonenumber
                    this.agentData.agentgender = newVal.sex
                    this.agentData.agentcertificatenumber = newVal.enterpriseInfo.idcard
                    // 经办人用户ID
                    // 原来取的id，目前扫码登录id是空的，尝试取userId
                    this.agentData.agentuserid = newVal.userId
                    // 通过 统一社会信用代码 查询 登录用户的联系人信息/登录用户的办公地址信息
                    this.getUserContactData(newVal.tyshxydm)
                    this.getUserAddressData(newVal.tyshxydm)
                }
                // 通过 统一社会信用代码 查询 企业信息
                this.getCompanyData(newVal.tyshxydm)
            },
        },
        'stepInfo.active'(newVal, oldVal) {
            if (oldVal < newVal) {
                // 切换页面内容时，滚动到顶部，避免用户体验不好
                let animate = function () {
                    let scrollTop = document.documentElement.scrollTop - 50
                    document.documentElement.scrollTop = scrollTop < 0 ? 0 : scrollTop
                    if (0 < document.documentElement.scrollTop) {
                        window.requestAnimationFrame(animate)
                    }
                }
                window.requestAnimationFrame(animate)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/styles/com/theme.scss";

.banner-size {
    height: 130px;
    background: url("~@/assets/images/sub_banner.png") no-repeat 100% / cover;
    .banner-inner {
        display: -webkit-flex;
        display: flex;
        align-items: center;
        width: 1200px;
        height: 100%;
        margin: 0 auto;

        .banner-fMin {
            margin-left: 15px;
        }
    }
}
.pd-content {
}
.pd-title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #000000;
}
::v-deep .pd-steps {
    margin: 20px auto;
}
.container {
    padding-right: 70px;
    padding-left: 70px;
    margin: 0 auto;
}
::v-deep .personal {
    overflow: hidden;
}
::v-deep .notice {
    margin-top: 20px;
}
.step-confirm {
    ::v-deep .el-input__inner,
    ::v-deep .el-input-group__prepend,
    ::v-deep .el-textarea__inner {
        border: none;
        color: #333333;
        background: none;
    }
    ::v-deep .el-input-group__prepend {
        padding-left: 15px;
    }
    .confirm-project {
        ::v-deep .el-input-number__decrease,
        ::v-deep .el-input-number__increase {
            display: none;
        }
        ::v-deep .el-textarea__inner {
            resize: none;
        }
    }
}
.step-success {
    text-align: center;

    .step-success-icon {
        position: relative;
        width: calc(8rem + 20px);
        height: calc(8rem + 20px);
        padding: 10px;
        margin: 60px auto 30px auto;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background-color: rgba($col-green, 0.2);
            z-index: 0;
        }
        .el-icon-success {
            position: relative;
            font-size: 8rem;
            color: $col-green;
            z-index: 1;
        }
    }

    .step-success-text {
        max-width: 640px;
        margin: 0 auto 60px auto;
        span {
            font-weight: bold;
            color: #333333;
        }
    }
}
.footBtns {
    margin-top: 20px;
    text-align: center;
}
</style>
